var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{attrs:{"type":"daterange","range-separator":"-","start-placeholder":"开始日期","end-placeholder":"结束日期","value-format":"yyyy-MM-dd"},on:{"change":_vm.onDateRangeChange},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }